export default function Mission() {
  return (
    <section className="my-16 px-4 md:px-8">
      <div 
        className="relative rounded-3xl shadow-2xl overflow-hidden bg-gradient-to-br from-main/5 via-white to-accent/5 border border-main/10"
      >
        <div className="relative z-10 py-16 px-6 md:px-20 lg:px-40">
          <div className="flex justify-center items-center gap-4 mb-6">
            <div className="h-[2px] w-16 bg-accent rounded"></div>
            <span className="text-accent text-4xl drop-shadow-sm">🕉️</span>
            <div className="h-[2px] w-16 bg-accent rounded"></div>
          </div>
          
          <h2 className="leading-normal text-heads text-4xl md:text-5xl text-center font-bold mb-12 font-Philosopher drop-shadow-sm">
            विजयते श्रीकृष्ण-संकीर्तनम
          </h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* English Mission Card */}
            <div className="bg-gradient-to-br from-bgWarm to-[#fdf8f0] rounded-3xl p-8 md:p-10 border-t-4 border-accent shadow-2xl transform transition duration-500 hover:-translate-y-2 relative overflow-hidden group flex flex-col">
              <div className="absolute top-0 right-0 w-40 h-40 bg-accent/10 rounded-full blur-3xl pointer-events-none transition duration-500 group-hover:bg-accent/20"></div>
              
              <div className="flex justify-center mb-8">
                 <span className="text-4xl">🕊️</span>
              </div>
              
              <p className="font-Philosopher text-lg md:text-xl leading-relaxed text-justify mb-10 text-heads/85 font-medium px-2">
                Our mission to spread the devotion (Divine love & service to
                God). Because by divine love & selfless service, we find the
                ultimate aim of human life, beloved God, true peace and divine
                height.
              </p>
              
              <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white shadow-sm text-center transform transition group-hover:scale-[1.02] duration-500 relative mt-auto">
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white text-sm font-bold px-4 py-1.5 rounded-full shadow-md tracking-wider">
                  Divine Quote
                </div>
                <p className="text-mainDark font-bold italic mb-2 mt-3 drop-shadow-sm text-lg md:text-xl leading-relaxed">"The soul is my Gopi, the Supreme Soul Shri Krishna."</p>
                <p className="text-mainDark font-bold italic mb-6 drop-shadow-sm text-lg md:text-xl leading-relaxed">"Sankirtan is my life, service is my duty."</p>
                <p className="text-heads/70 font-bold text-sm tracking-widest uppercase">- Pt. Mahesh Das</p>
              </div>
            </div>

            {/* Hindi Mission Card */}
            <div className="bg-gradient-to-br from-bgWarm to-[#fdf8f0] rounded-3xl p-8 md:p-10 border-t-4 border-main shadow-2xl transform transition duration-500 hover:-translate-y-2 relative overflow-hidden group flex flex-col">
              <div className="absolute top-0 right-0 w-40 h-40 bg-main/10 rounded-full blur-3xl pointer-events-none transition duration-500 group-hover:bg-main/20"></div>
              
              <div className="flex justify-center mb-8">
                 <span className="text-4xl">🪔</span>
              </div>
              
              <p className="font-Philosopher text-lg md:text-xl leading-relaxed text-justify mb-10 text-heads/85 font-medium px-2">
                हमारा मिशन भक्ति (दिव्य प्रेम और भगवान की सेवा) का प्रसार करना
                है। क्योंकि दिव्य प्रेम और निःस्वार्थ सेवा से हम मानव जीवन का
                अंतिम लक्ष्य, प्यारे भगवान, सच्ची शांति और दिव्य ऊंचाई पाते
                हैं।
              </p>
              
              <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white shadow-sm text-center transform transition group-hover:scale-[1.02] duration-500 relative mt-auto">
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-main text-white text-sm font-bold px-4 py-1.5 rounded-full shadow-md tracking-wider">
                  पवित्र विचार
                </div>
                <p className="text-mainDark font-bold italic mb-2 mt-3 drop-shadow-sm text-lg md:text-xl leading-relaxed">"आत्मा मेरी गोपी है , परमात्मा श्री कृष्ण।"</p>
                <p className="text-mainDark font-bold italic mb-6 drop-shadow-sm text-lg md:text-xl leading-relaxed">"संकीर्तन मेरा प्राण है , सेवा मेरा कर्त्तव्य।।"</p>
                <p className="text-heads/70 font-bold text-sm tracking-widest uppercase">- पं. महेश दास</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
